import classNames from 'classnames';
import React from 'react';

export interface AlphaCheckboxProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const AlphaCheckbox: React.FC<AlphaCheckboxProps> = ({
  checked,
  disabled,
  onChange,
  className = '',
  labelProps = {},
  inputProps = {},
}) => {
  const { className: labelClassName, ...restLabelProps } = labelProps;
  const { className: inputClassName, ...restInputProps } = inputProps;

  return (
    <label
      {...restLabelProps}
      className={`
        inline-flex cursor-pointer items-center
        ${className} ${labelClassName ?? ''}
      `}
    >
      <input
        {...restInputProps}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.currentTarget.checked)}
        className={`
          peer sr-only
          ${inputClassName ?? ''}
        `}
      />
      <span
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        className={classNames(
          `
          peer:hover:shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.10),0px_2px_4px_-2px_rgba(0,0,0,0.10)]
          inline-flex size-5 items-center justify-center
          rounded-[--roundness-s] border
          transition-colors
          peer-checked:border-buttons/primary peer-checked:bg-buttons/primary
          peer-checked:hover:border-buttons/primary-hover peer-checked:hover:shadow-md peer-checked:hover:bg-buttons/primary-hover
          peer-focus:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-black
        `,
          {
            'border-borders/form-default hover:border-borders/form-hover':
              !checked && !disabled,
            'border-borders/default': disabled,
          },
        )}
      >
        {checked && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
          >
            <path
              d="M4.95836 9.70983L0.512939 5.26441L1.40377 4.37337L4.95836 7.92796L12.5963 0.290039L13.4871 1.18108L4.95836 9.70983Z"
              fill="white"
            />
          </svg>
        )}
      </span>
    </label>
  );
};

export default AlphaCheckbox;
